var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"card",attrs:{"flat":""}},[_vm._t("img-content"),_c('v-card-text',{staticClass:"text-box d-flex justify-space-between align-content-center"},[_vm._t("text-content")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }